import React from 'react';
import Avatar from 'material-ui/Avatar';

const colors = ['#F44336', '#00BCD4', '#FF5722', '#795548', '#4CAF50', '#9C27B0'];

function NameAvatar({ id, name }) {
  return <Avatar
      size={50}
      style={{
        backgroundColor: colors[id % colors.length],
      }}
    >
      {name ? name.charAt(0) : ''}
    </Avatar>;
}

export default NameAvatar;



/** WEBPACK FOOTER **
 ** ./components/NameAvatar.js
 **/